<template>
  <v-row>
    <v-col cols="12" md="6">
      <e-dado-do-aluno rotulo="Nome completo" :valor="caso.aluno" />
      <e-dado-do-aluno rotulo="Matrícula" :valor="caso.matricula" />
      <e-dado-do-aluno rotulo="Escola" :valor="caso.escola" />
      <e-dado-do-aluno rotulo="Turma" :valor="turmaComTurno" />
      <e-dado-do-aluno rotulo="Filiação 1" :valor="caso.filiacao1" />
      <e-dado-do-aluno rotulo="Telefone do responsável" :valor="caso.telefone_responsavel" />
    </v-col>

    <v-col cols="12" md="6">
      <e-dado-do-aluno rotulo="Faltas injustificadas">
        <e-faltas-do-limite
          :faltas="caso.faltas_injustificadas"
          :limite="caso.limite_faltas"
          :percentual="caso.percentual_limite_faltas"
        />
      </e-dado-do-aluno>

      <e-dado-do-aluno rotulo="Frequência Escolar Anual">
        <div v-if="caso.percentual_frequencia !== null">
          <span class="text-body-1">{{ percentualLegivel }}</span>
          <div class="text-caption grey--text">
            {{ caso.faltas_injustificadas }} faltas em {{ caso.carga_horaria_total }} horas-aula
            previstas no ano
          </div>
        </div>
        <span v-else class="grey--text">Turma sem carga horária cadastrada</span>
      </e-dado-do-aluno>

      <e-dado-do-aluno rotulo="Dias letivos seguidos sem nenhuma presença">
        <div class="text-body-1">{{ caso.dias_consecutivos_ausencia_total }}</div>
      </e-dado-do-aluno>

      <e-dado-do-aluno rotulo="Data da última presença" :valor="ultimaPresenca" />
    </v-col>
  </v-row>
</template>

<script>
import EDadoDoAluno from "@/components/BuscaAtiva/EDadoDoAluno.vue";
import EFaltasDoLimite from "@/components/BuscaAtiva/EFaltasDoLimite.vue";

export default {
  name: "EDadosGeraisTab",
  components: { EDadoDoAluno, EFaltasDoLimite },
  props: {
    caso: { type: Object, required: true },
  },
  computed: {
    turmaComTurno() {
      return [this.caso.turma, this.caso.turno].filter(Boolean).join(" — ");
    },
    percentualLegivel() {
      return `${this.caso.percentual_frequencia.toString().replace(".", ",")}%`;
    },
    ultimaPresenca() {
      if (!this.caso.ultima_presenca) return null;
      const [ano, mes, dia] = this.caso.ultima_presenca.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>
